
import { z } from "zod";

export const PreferredContactMethodValues = ["CALL", "EMAIL", "TEXT"] as const;
export const PreferredContactMethodSchema = /* @__PURE__ */ z.enum(PreferredContactMethodValues);
export const PreferredContactMethod: (typeof PreferredContactMethodSchema)["enum"] = { "CALL": "CALL", "EMAIL": "EMAIL", "TEXT": "TEXT" };
export type PreferredContactMethod = (typeof PreferredContactMethodValues)[number];
export const PreferredContactMethodDisplayNames = { "CALL": "Call",
"EMAIL": "Email",
"TEXT": "Text", } satisfies Record<PreferredContactMethod, string>;
